import { CardAsyncTokenRequest } from "@kushki/js/lib/types/card_async_token_request";
import { ErrorMessage } from "components/Error/ErrorMessageComponent";
import { Input } from "components/Input/InputComponent";
import { Footer } from "components/UI/Footer/FooterComponent";
import { PayButton } from "components/UI/PayButton/PayButtonComponent";
import {
  getCardAsyncToken,
  setDirty,
  updateInput,
} from "containers/CardAsync/store/ActionCreators";
import { CardSubscriptionAsyncComponent } from "containers/CardSubscriptionAsync/CardSubscriptionAsyncComponent";
import * as React from "react";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { sendParametersToParent } from "root/shared/Messenger";
import { PaymenMethodEnum } from "root/shared/PaymenMethodEnum";
import { PciImages } from "root/shared/PciImages";
import { calculateTotalAmount, checkValidity } from "root/shared/Utility";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { ICardAsyncFormProps } from "types/cajita_store";
import { ICardAsyncActionCreator } from "types/card_async_action_creator";
import { ITransferAmount } from "types/transfer_amount";
import "./assets/css/styles.css";

/**
 * CardAsync StateFull Component
 */
class CardAsync extends React.Component<
  ICardAsyncFormProps & LocalizeContextProps
> {
  constructor(props: ICardAsyncFormProps & LocalizeContextProps) {
    super(props);
    this.props.addTranslation(this.props.translation);
    this._inputHandler = this._inputHandler.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
  }

  public componentDidUpdate(): void {
    // istanbul ignore else
    if (
      this.props.token !== undefined &&
      this.props.token !== "" &&
      !this.props.is_subscription
    )
      sendParametersToParent({
        token: this.props.token,
        paymentMethod: PaymenMethodEnum.CARD_ASYNC,
      });

    return;
  }

  public render(): React.ReactNode {
    return !this.props.isCardAsyncAvailable ? (
      <Container>
        <Row className={"text-center"}>
          <Col>
            <h4>
              <Translate id="notAvailableCardAsync" />
            </h4>
          </Col>
        </Row>
        <div className={"webpayPlusImage"} />
        <div className={"poweredBy"} />
      </Container>
    ) : this.props.is_subscription ? (
      <CardSubscriptionAsyncComponent />
    ) : (
      <form onSubmit={this._submitHandler} autoComplete="off" noValidate={true}>
        <ErrorMessage />

        <div className="card-async-container">
          <div className="section">
            <div className={`card-async-${PciImages.webpayPlusImage}`} />
          </div>
          <div className="section">
            <Row>
              <Col>
                <Input
                  {...this.props.emailInput}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>

          <PayButton
            isValid={this.props.isValid}
            totalAmount={this.props.cardAsyncAmount}
            isSubscription={false}
            currency={this.props.currency}
            disable={this.props.disablePayButton}
          />
        </div>

        <Footer />
      </form>
    );
  }

  private _inputHandler(id: string, newValue: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    new_input.value = newValue;
    new_input.valid = checkValidity(newValue, new_input.rules);
    this.props.onChangeInput(new_input);
  }

  private _submitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();

    const cardAsyncTokenRequest: CardAsyncTokenRequest = {
      currency: this.props.currency,
      email: this.props.emailInput.value,
      totalAmount: this.props.cardAsyncAmount,
      returnUrl: this.props.returnUrl,
    };

    this.props.requestToken(cardAsyncTokenRequest);
  }
}

type TCardAsyncCurrency = "USD" | "COP" | "PEN" | "CLP" | "UF";

const mapStateToProps: (state: CajitaStore) => ICardAsyncFormProps = (
  state: CajitaStore
): ICardAsyncFormProps => ({
  ...state.card_async,
  currency: state.config.currency as TCardAsyncCurrency,
  is_subscription: state.config.is_subscription,
  cardAsyncAmount:
    typeof state.config.amount === "object"
      ? calculateTotalAmount(state.config.amount as ITransferAmount)
      : state.config.amount,
  returnUrl: state.config.return_url,
  disablePayButton: state.config.disablePayButton,
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, ICardAsyncActionCreator>
): object => ({
  onChangeInput: (payload: IInputProps): void => dispatch(updateInput(payload)),
  onTouched: (payload: IInputProps): ICardAsyncActionCreator =>
    dispatch(setDirty(payload)),
  requestToken: (payload: CardAsyncTokenRequest): void =>
    dispatch(getCardAsyncToken(payload)),
});

const CardAsyncComponent: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize<ICardAsyncFormProps & LocalizeContextProps>(CardAsync));

export { CardAsyncComponent };



// WEBPACK FOOTER //
// ./src/containers/CardAsync/CardAsyncComponent.tsx